const Tray_Actions_Types = Object.freeze({
  OPEN: 'open',
  CLOSE: 'close',
  CHANGE: 'change',
  SWITCH: 'switch',
});

export { Tray_Actions_Types }; // eslint-disable-line import/prefer-default-export
